module.exports = __webpack_public_path__ + "img/calendar.223751b1.svg";